import { Link, NavLink } from "react-router-dom";
import "./index.css";
import LogoW from "../../assets/images/FrameW.png";
import LogoSubtitle from "../../assets/images/logo_sub.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGamepad,
  faHome,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faGithub,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

const Navbar = () => (
  <div className="nav-bar">
    <Link className="logo" to="/">
      <img src={LogoW} className="logo-w" alt="logo" />
      <img className="sub-logo" src={LogoSubtitle} alt="wilson" />
    </Link>

    <nav>
      <NavLink exact="true" activeclassname="active" to="/">
        <FontAwesomeIcon icon={faHome} color="4d4d4e" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="about-link"
        to="/about"
      >
        <FontAwesomeIcon icon={faUser} color="4d4d4e" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="project-link"
        to="/projects"
      >
        <FontAwesomeIcon icon={faGamepad} color="4d4d4e" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="contact-link"
        to="/contact"
      >
        <FontAwesomeIcon icon={faEnvelope} color="4d4d4e" />
      </NavLink>
    </nav>
    <ul>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/wilsonrchen/"
          className="linkedin-link"
        >
          <FontAwesomeIcon icon={faLinkedin} color="4d4d4e" />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://github.com/Wilsonrchen"
          className="github-link"
        >
          <FontAwesomeIcon icon={faGithub} color="4d4d4e" />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/wilsonrchen/"
          className="instagram-link"
        >
          <FontAwesomeIcon icon={faInstagram} color="4d4d4e" />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/wilson.r.chen/"
          className="facebook-link"
        >
          <FontAwesomeIcon icon={faFacebook} color="4d4d4e" />
        </a>
      </li>
    </ul>
  </div>
);

export default Navbar;
